import React, { useCallback, useContext, useEffect, useState } from 'react';
import './Siteplan.css';
import lotMap from '../../assets/lotMap.png';
import siteplan from '../../assets/siteplan.jpg';
import ImageMapper from 'react-img-mapper';
import { FirebaseContext } from '../../context/firebase';
import * as PROJECT_CODE from '../../constants/projectCode';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import { TransformWrapper, TransformComponent } from 'react-zoom-pan-pinch';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import CloseIcon from '@material-ui/icons/Close';
import HouseIcon from '@material-ui/icons/House';
import {
	Chip,
	Input,
	MenuItem,
	Select,
	TablePagination,
} from '@material-ui/core';
import { forEach } from 'lodash';
import { useHistory } from 'react-router';

import { CircularProgress } from '@material-ui/core';
import Modal from '../layout/modal/Modal';
import Clients from '../clients/Clients';

function Siteplan() {
	const [hoveredArea, setHoveredArea] = useState();
	const { firebase } = useContext(FirebaseContext);
	const [lotList, setLotList] = useState([]);
	const [priceDetailList, setPriceDetailList] = useState();
	const [userType, setUserType] = useState('');
	const [listOfLots, setListOfLots] = useState([]);
	const [availability, setAvailability] = useState({});
	const [salesAgent, setSalesAgent] = useState([]);
	const [personName, setPersonName] = useState();
	const [clickLotInfo, setClickLotInfo] = useState();
	const [lotId, setLotId] = useState();
	const [mapCoords, setMapCoords] = useState({
		'name': 'my-map',
	});
	const [render, setRender] = useState(0);
	const [order, setOrder] = useState('asc');
	const [orderBy, setOrderBy] = useState('calories');
	const [selected, setSelected] = useState([]);
	const [page, setPage] = useState(0);
	const [dense, setDense] = useState(false);
	const [rowsPerPage, setRowsPerPage] = useState(5);
	const [toolTipData, setToolTipData] = useState([]);
	const [center, setCenter] = useState();
	const [toolTipHouseIconAvailable, setToolTipHouseIconAvailable] = useState(
		[]
	);
	const [toolTipHouseIconPending, setToolTipHouseIconPending] = useState([]);
	const [show, setShow] = useState(false);

	const closeModalHandler = () => setShow(false);

	const handleChangePage = (event, newPage) => {
		setPage(newPage);
	};

	const handleChangeRowsPerPage = (event) => {
		setRowsPerPage(parseInt(event.target.value, 10));
		setPage(0);
	};

	const history = useHistory();

	function descendingComparator(a, b, orderBy) {
		if (b[orderBy] < a[orderBy]) {
			return -1;
		}
		if (b[orderBy] > a[orderBy]) {
			return 1;
		}
		return 0;
	}

	function getComparator(order, orderBy) {
		return order === 'desc'
			? (a, b) => descendingComparator(a, b, orderBy)
			: (a, b) => -descendingComparator(a, b, orderBy);
	}

	function stableSort(array, comparator) {
		const stabilizedThis = array.map((el, index) => [el, index]);
		stabilizedThis.sort((a, b) => {
			const order = comparator(a[0], b[0]);
			if (order !== 0) return order;
			return a[1] - b[1];
		});
		return stabilizedThis.map((el) => el[0]);
	}

	useEffect(() => {
		firebase.auth().onAuthStateChanged(async (user) => {
			if (user) {
				var currentUserId = firebase.auth().currentUser.uid;
				var currentUserType;

				console.log('Current user Id; ' + currentUserId);
				await firebase
					.database()
					.ref('/users/' + currentUserId + '/userType')
					.once('value', function (snapshot) {
						currentUserType = snapshot.val();
						console.log('THIS IS USER TYPE SITEPPLAN: ' + currentUserType);
					});
				setUserType(currentUserType);
			}
		});
	}, [userType]);

	//setting color of lots depending if its available, sold out or pending
	useEffect(() => {
		firebase
			.database()
			.ref('/kavtek_clients/' + PROJECT_CODE.projectCode + '/lots')
			.orderByChild('available')
			.equalTo('soldout')
			.on('value', (snapshot) => {
				snapshot.forEach((lot) => {
					var child = firebase
						.database()
						.ref('/kavtek_clients/' + PROJECT_CODE.projectCode + '/lots/')
						.child(lot.key)
						.child('mapCoords');

					var id;

					var availability = lot.val().available;

					console.log('available: ' + availability);

					child.on('value', (snapshot) => {
						id = snapshot.val().id;
					});

					child.update({
						preFillColor: 'rgba(255, 20, 20, 0.47)',
						active: true,
						name: availability,
						disabled: false,
					});
				});
			});

		firebase
			.database()
			.ref('/kavtek_clients/' + PROJECT_CODE.projectCode + '/lots')
			.orderByChild('available')
			.equalTo('available')
			.on('value', (snapshot) => {
				snapshot.forEach((lot) => {
					var child = firebase
						.database()
						.ref('/kavtek_clients/' + PROJECT_CODE.projectCode + '/lots/')
						.child(lot.key)
						.child('mapCoords');

					var id;

					child.on('value', (snapshot) => {
						id = snapshot.val().id;
					});

					console.log('this is the id: ' + id);

					child.update({
						preFillColor: '',
						active: true,
						name: id,
						disabled: false,
					});
				});
			});
		firebase
			.database()
			.ref('/kavtek_clients/' + PROJECT_CODE.projectCode + '/lots')
			.orderByChild('available')
			.equalTo('pending')
			.on('value', (snapshot) => {
				snapshot.forEach((lot) => {
					var child = firebase
						.database()
						.ref('/kavtek_clients/' + PROJECT_CODE.projectCode + '/lots/')
						.child(lot.key)
						.child('mapCoords');

					var id;

					child.on('value', (snapshot) => {
						id = snapshot.val().id;
					});

					child.update({
						preFillColor: 'rgba(255, 255, 168, 0.70)',
						active: true,
						name: id,
						disabled: false,
					});
				});
			});
	}, []);

	//setting up the map
	useEffect(() => {
		async function getData() {
			await firebase
				.database()
				.ref('/kavtek_clients/' + PROJECT_CODE.projectCode + '/lots')
				.once('value', (snapshot) => {
					var mapCoordObj;
					var areaArr = [];
					var centerArr = [];

					snapshot.forEach((lot) => {
						var mapCoordVal = lot.val().mapCoords;

						var coordsArray = mapCoordVal.coords;

						var maxX, maxY, center;
						var coord,
							minX = (maxX = parseInt(coordsArray[0], 10)),
							minY = (maxY = parseInt(coordsArray[1], 10));

						for (var i = 0, l = coordsArray.length; i < l; i++) {
							coord = parseInt(coordsArray[i], 10);
							if (i % 2 == 0) {
								// Even values are X coordinates
								if (coord < minX) {
									minX = coord;
								} else if (coord > maxX) {
									maxX = coord;
								}
							} else {
								// Odd values are Y coordinates
								if (coord < minY) {
									minY = coord;
								} else if (coord > maxY) {
									maxY = coord;
								}
							}
						}

						// console.log('maxX: ' + minX + ' ' + maxX);

						center = [
							parseInt((minX + maxX) / 2, 10),
							parseInt((minY + maxY) / 2, 10),
						];

						// DO NOT REMOVE THIS COMMENT ----------------------

						//Uncomment to populate db then comment it back!

						// var lotRef = firebase
						// 	.database()
						// 	.ref('/kavtek_clients/' + PROJECT_CODE.projectCode + '/lots')
						// 	.child(lot.key);

						// lotRef.update({
						// 	center: center,
						// });
						// -------------------------------------------------
						// console.log('THis is the center: ' + center);

						areaArr.push(mapCoordVal);

						var mapCoordChild = lot.child('mapCoords');

						// console.log('mapCoordChild: ' + JSON.stringify(mapCoordChild));

						// mapCoordChild.forEach((child) => {
						// 	console.log('childdddd: ' + JSON.stringify(child));
						// });

						// console.log('mapCoordVal ' + JSON.stringify(mapCoordVal));

						mapCoordObj = {
							...mapCoords,
							areas: areaArr,
						};
					});

					// console.log('areaa: ' + areaArr);

					setMapCoords(mapCoordObj);
					// console.log('mapppp: ' + JSON.stringify(mapCoordObj));
				});
		}
		getData();
	}, [availability, render]);

	//set default value for multi select (assigning sales agent)
	useEffect(() => {
		firebase
			.database()
			.ref('/kavtek_clients/' + PROJECT_CODE.projectCode + '/lots')
			.on('value', (snapshot) => {
				var lotDetails;
				snapshot.forEach((lot) => {
					var lotName = lot.key;

					var sa = lot.val().salesAgent;

					if (sa === undefined) {
						sa = [];
					}

					// console.log('keyssss: ' + sa);

					lotDetails = {
						...lotDetails,
						['agent' + lotName]: sa,
					};
				});
				// console.log('lotDetails ' + JSON.stringify(lotDetails));
				setPersonName(lotDetails);
			});
	}, []);

	useEffect(() => {
		firebase
			.database()
			.ref('/kavtek_clients/' + PROJECT_CODE.projectCode + '/lots')
			.on('value', (snapshot) => {
				var lotListArr = [];
				var availabilityArr = [];
				var lotAssignment;
				var availabilityObj;

				snapshot.forEach((lot) => {
					var lotName = lot.val().lotId;
					var availabilityValue = lot.val().available;

					lotAssignment = {
						lot: lotName,
					};

					availabilityObj = {
						...availabilityObj,
						[`lot` + lotName]: availabilityValue,
					};

					// console.log(availabilityObj);
					lotListArr.push(lotAssignment);
				});

				setAvailability(availabilityObj);
				setListOfLots(lotListArr);
				// console.log('listArr: ' + lotListArr);
				// console.log('availabilityArr: ' + JSON.stringify(availabilityArr));
			});
	}, []);

	useEffect(() => {
		setRender(render + 1);
	}, []);

	//get sales agent
	useEffect(() => {
		firebase
			.database()
			.ref('/kavtek_clients/' + PROJECT_CODE.projectCode + '/salesAgents')
			.on('value', (snapshot) => {
				var salesAgentArr = [];

				snapshot.forEach((sa) => {
					var name = sa.val().name;

					salesAgentArr.push(name);
				});

				setSalesAgent(salesAgentArr);

				// console.log('Sales agent: ' + salesAgentArr);
			});
	}, []);

	//handle radio buttons for availability
	const handleAvailability = (e) => {
		var lotName = e.target.name;
		var availabilityValue = e.target.value;

		setAvailability({
			...availability,
			['lot' + lotName]: availabilityValue,
		});

		var lotRef = firebase
			.database()
			.ref('/kavtek_clients/' + PROJECT_CODE.projectCode + '/lots/' + lotName);

		console.log('Date now: ' + Date.now());

		if (availabilityValue === 'soldout') {
			lotRef.update({
				dateSold: Date.now(),
			});
		} else if (
			availabilityValue === 'available' ||
			availabilityValue === 'pending'
		) {
			lotRef.update({
				dateSold: '',
			});
		}

		lotRef.update({
			available: availabilityValue,
		});
	};

	const handleSalesAgent = (e) => {
		// setPersonName({ ...personName, ['agent' + lotName]: e.target.value });
		var lotName = e.target.name;
		// setPersonName(e.target.value );
		setPersonName({ ...personName, ['agent' + lotName]: e.target.value });

		console.log('per name: ' + JSON.stringify(personName));

		// console.log('valueval ' + valueVal);

		async function sendToDatabase() {
			var valueVal = JSON.stringify(e.target.value);
			var lotRef = await firebase
				.database()
				.ref(
					'/kavtek_clients/' + PROJECT_CODE.projectCode + '/lots/' + lotName
				);

			lotRef.update({
				salesAgent: JSON.parse(valueVal),
			});
		}

		sendToDatabase();
	};

	const handleSelectLot = useCallback(async (e) => {
		try {
			var currentUserId = firebase.auth().currentUser.uid;
			var currentUserEmail = firebase.auth().currentUser.email;
			var currentUserType;
			var currentUserPhoneNumber;
			var currentUserName;
			var lotId = e.currentTarget.dataset.lotid;

			await firebase
				.database()
				.ref('/users/' + currentUserId)
				.once('value', (snapshot) => {
					currentUserType = snapshot.val().userType;
					currentUserPhoneNumber = snapshot.val().phoneNumber;
					currentUserName = snapshot.val().fullName;

					console.log(
						'Type: ' +
							currentUserType +
							', username: ' +
							currentUserName +
							', phone: ' +
							currentUserPhoneNumber
					);

					var detailsUser = {
						thisEmail: currentUserEmail,
						thisName: currentUserName,
						thisUserType: currentUserType,
						thisPhone: currentUserPhoneNumber,
						thisUID: currentUserId,
					};

					console.log('Details user: ' + JSON.stringify(detailsUser));

					if (userType === 'client') {
						history.push({
							pathname: '/doc-client',
							state: {
								userDetail: detailsUser,
								sellerFullName: currentUserName,
								sellerPhone: currentUserPhoneNumber,
								lotId: lotId,
							},
						});
					}
				});
		} catch (error) {
			console.log(error);
		}
	});

	const handleClickLot = (area) => {
		console.log(`${area.name} is clicked`);

		function capitalizeFirstLetter(string) {
			return string.charAt(0).toUpperCase() + string.slice(1);
		}

		firebase.auth().onAuthStateChanged(function (user) {
			if (user) {
				var buildingArr = [];
				var priceDetailArr = [];
				var buildingDetails;
				var lotSelected = area.name;
				firebase
					.database()
					.ref(
						'/kavtek_clients/' +
							PROJECT_CODE.projectCode +
							'/lots/' +
							lotSelected +
							'/buildings/'
					)
					.on('value', (snapshot) => {
						snapshot.forEach((snap) => {
							// console.log(snap.val()); //building name

							snap.forEach((building) => {
								buildingDetails = {
									name: capitalizeFirstLetter(building.key),
									price: building.val().priceList,
									sqft: building.val().sqft,
								};

								buildingArr.push(buildingDetails);
							});
						});
						console.log(buildingArr);
						setLotList(buildingArr);
					});

				var lotId = area.id;
				var lotObj;

				firebase
					.database()
					.ref('/kavtek_clients/' + PROJECT_CODE.projectCode + '/lots/' + lotId)
					.on('value', (snapshot) => {
						var price = snapshot.val().lotPrice;
						var availability = snapshot.val().available;

						lotObj = {
							price: price,
							availability: availability,
							lot: lotId,
							center: area.center,
						};

						setLotId(lotObj.lot);

						setClickLotInfo(lotObj);
					});

				// setLotList(buildingArr);
			}
		});
	};

	useEffect(() => {
		firebase
			.database()
			.ref('/kavtek_clients/' + PROJECT_CODE.projectCode + '/lots')
			.orderByChild('available')
			.equalTo('soldout')
			.once('value', (snapshot) => {
				var tooltipDataArr = [];
				snapshot.forEach((lot) => {
					var center = lot.val().center;

					console.log('CENTERou: ' + JSON.stringify(center));

					var centerObj = {
						center: center,
					};

					tooltipDataArr.push(centerObj);
				});

				setTimeout(() => {
					setToolTipData(tooltipDataArr);
				}, 1000);
			});
	}, [mapCoords]);

	useEffect(() => {
		firebase
			.database()
			.ref('/kavtek_clients/' + PROJECT_CODE.projectCode + '/lots')
			.orderByChild('available')
			.equalTo('available')
			.once('value', (snapshot) => {
				var tooltipDataArr = [];
				snapshot.forEach((lot) => {
					var center = lot.val().center;

					console.log('CENTERou: ' + JSON.stringify(center));

					var centerObj = {
						center: center,
					};

					tooltipDataArr.push(centerObj);
				});

				setTimeout(() => {
					setToolTipHouseIconAvailable(tooltipDataArr);
				}, 1000);
			});
		firebase
			.database()
			.ref('/kavtek_clients/' + PROJECT_CODE.projectCode + '/lots')
			.orderByChild('available')
			.equalTo('pending')
			.once('value', (snapshot) => {
				var tooltipDataArr = [];
				snapshot.forEach((lot) => {
					var center = lot.val().center;

					console.log('CENTERou: ' + JSON.stringify(center));

					var centerObj = {
						center: center,
					};

					tooltipDataArr.push(centerObj);
				});

				setTimeout(() => {
					setToolTipHouseIconPending(tooltipDataArr);
				}, 1000);
			});
	}, [mapCoords]);

	const enterArea = (area) => {
		console.log('This is the area: ' + JSON.stringify(area));
		setHoveredArea(area);

		// var lotId = area.id;
		// var lotObj;

		// firebase
		// 	.database()
		// 	.ref('/kavtek_clients/' + PROJECT_CODE.projectCode + '/lots/' + lotId)
		// 	.on('value', (snapshot) => {
		// 		var price = snapshot.val().lotPrice;
		// 		var availability = snapshot.val().available;

		// 		lotObj = {
		// 			price: price,
		// 			availability: availability,
		// 			lot: lotId,
		// 		};

		// 		setClickLotInfo(lotObj);
		// 	});
	};

	const handleMouseMove = (area, index, event) => {
		console.log(area);
		console.log('index: ' + index);
		// console.log('event: ' + JSON.stringify(event));
		return {
			top: `${area.center[1]}px`,
			left: `${area.center[0] + 90}px`,
		};
	};

	const handleMouseLeave = (event) => {
		setHoveredArea();
	};

	const handleShowPrice = (e) => {
		var btnId = e.currentTarget.id;

		console.log(btnId);
		setPriceDetailList(btnId);
	};

	const useStyles = makeStyles((theme) => ({
		root: {
			minWidth: 275,
			margin: 10,

			'&:nth-child(1)': {
				marginLeft: '0',
			},
		},

		cardsGroup: {
			display: 'flex',
			flexWrap: 'nowrap',
			marginLeft: '6.5em',
			overflowX: 'scroll',
			marginRight: '6.5em',
		},

		title: {
			fontSize: 21,
		},
		pos: {
			marginBottom: 12,
		},
		btnGroup: {
			display: 'flex',
		},

		btn: {
			margin: '8px',
			backgroundColor: '#438afe',
			color: 'white',
			marginBottom: '10px',
		},
		mapImage: {
			position: 'relative',
			width: '1013px',
			height: 'auto',
			margin: '0 auto',
		},
		table: {
			minWidth: 650,
		},
		tableContainer: {
			marginTop: '4em',
			width: '85%',
			margin: '3em auto',
		},
		radioGroup: {
			display: 'flex',
			flexDirection: 'row',
		},
		radioBtn: {
			color: 'rgb(71, 131, 230) !important',
		},
		formControl: {
			margin: theme.spacing(1),
			minWidth: 120,
			maxWidth: 300,
		},
		chips: {
			display: 'flex',
			flexWrap: 'wrap',
		},
		chip: {
			margin: 2,
		},
		noLabel: {
			marginTop: theme.spacing(3),
		},
	}));

	const ITEM_HEIGHT = 48;
	const ITEM_PADDING_TOP = 8;
	const MenuProps = {
		PaperProps: {
			style: {
				maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
				width: 250,
			},
		},
	};

	function getStyles(name, personName, theme) {
		return {
			fontWeight:
				personName.indexOf(name) === -1
					? theme.typography.fontWeightRegular
					: theme.typography.fontWeightMedium,
		};
	}

	const styles = useStyles();
	const theme = useTheme();

	const toolTipStyle = (top, left) => {
		return {
			top: `${top}px`,
			left: `${left + 90}px`,
		};
	};

	const handleCloseTooltip = () => {
		setClickLotInfo();
	};

	return (
		<>
			{show && <div className='back-drop' onClick={closeModalHandler}></div>}
			<div className='siteplan-page'>
				<h2 id='siteplan-title'>Siteplan</h2>
				{console.log('mapCoord styles: ' + JSON.stringify(mapCoords.areas))}

				{mapCoords.areas && toolTipData ? (
					<div className='map-container'>
						<ImageMapper
							src={siteplan}
							map={mapCoords}
							stayHighlighted={'true'}
							areaKeyName={mapCoords.areas.id}
							fillColor={'rgba(71, 131, 230, 0.70)'}
							strokeColor={'rgba(71, 131, 230)'}
							onMouseEnter={(area) => {
								enterArea(area);
								handleMouseMove(area);
							}}
							onClick={(area) => {
								handleClickLot(area);
							}}
							onMouseLeave={(event) => {
								handleMouseLeave(event);
							}}
							className={styles.mapImage}
						/>
						{hoveredArea && (
							<span
								className='tooltip'
								style={{ ...handleMouseMove(hoveredArea) }}
							>
								{hoveredArea.name}
							</span>
						)}
						{clickLotInfo && (
							<span
								className='tooltip-click'
								style={{
									...toolTipStyle(
										clickLotInfo?.center[1],
										clickLotInfo?.center[0]
									),
								}}
							>
								{clickLotInfo && (
									<div className='tooltip-content'>
										<div className='close-tooltip' onClick={handleCloseTooltip}>
											<CloseIcon />
										</div>
										<h1>Lot {clickLotInfo?.lot}</h1>
										<p>Lot Status: {clickLotInfo?.availability}</p>
										<p>Premium: $ {clickLotInfo?.price}</p>
										{clickLotInfo?.availability !== 'soldout' && (
											<button
												className='tooltip-button btn btn-primary'
												data-lotid={clickLotInfo?.lot}
												onClick={(e) => {
													setShow(true);
													setClickLotInfo();
													handleSelectLot(e);
												}}
											>
												Select Lot
											</button>
										)}
									</div>
								)}
							</span>
						)}

						{console.log('tooltipData: ' + JSON.stringify(toolTipData))}
						{/* 
					{toolTipData?.map((tooltip) => {
						if (tooltip.center) {
							return (
								<div
									className='tooltip'
									style={{
										...toolTipStyle(tooltip?.center[1], tooltip?.center[0]),
									}}
								>
									SOLD
								</div>
							);
						}
					})} */}
						{toolTipHouseIconAvailable?.map((tooltip) => {
							if (tooltip.center) {
								return (
									<div
										className='tooltip-available'
										style={{
											...toolTipStyle(tooltip?.center[1], tooltip?.center[0]),
										}}
									>
										<HouseIcon />
									</div>
								);
							}
						})}
						{toolTipHouseIconPending?.map((tooltip) => {
							if (tooltip.center) {
								return (
									<div
										className='tooltip-pending'
										style={{
											...toolTipStyle(tooltip?.center[1], tooltip?.center[0]),
										}}
									>
										<HouseIcon />
									</div>
								);
							}
						})}
					</div>
				) : (
					<div className={styles.mapImage}>
						<CircularProgress />
					</div>
				)}

				{clickLotInfo && (
					<div className={styles.cardsGroup}>
						{console.log(hoveredArea)}
						{lotList?.map((lot) => {
							return (
								<Card className={styles.root} key={lot.name}>
									<CardContent>
										<Typography className={styles.pos} color='textSecondary'>
											Building Name
											<Typography
												className={styles.title}
												color='textPrimary'
												gutterBottom
											>
												{lot.name}
											</Typography>
											Building Number & Price
											{lot.price.map((priceItem) => {
												return (
													<>
														<Typography
															className={styles.title}
															color='textPrimary'
															gutterBottom
														>
															{priceItem.id} - ${priceItem.price}
														</Typography>
													</>
												);
											})}
											Building sqft
											<Typography
												className={styles.title}
												color='textPrimary'
												gutterBottom
											>
												{lot.sqft}
											</Typography>
										</Typography>
									</CardContent>
								</Card>
							);
						})}
					</div>
				)}
				<TableContainer component={Paper} className={styles.tableContainer}>
					{/* {console.log('availability first: ' + JSON.stringify(availability))} */}
					{userType === 'superadmin' ? (
						<>
							<Table className={styles.table} aria-label='Lot assignment table'>
								<TableHead>
									<TableRow>
										<TableCell>Lots</TableCell>
										<TableCell align='center'>Availability</TableCell>
										<TableCell align='center'>Assign Sales Agents</TableCell>
									</TableRow>
								</TableHead>
								<TableBody>
									{console.log('list of lots: ' + JSON.stringify(listOfLots))}
									{stableSort(listOfLots, getComparator(order, orderBy))
										.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
										.map((item, index) => {
											return (
												<TableRow key={item.lot}>
													<TableCell component='th' scope='row'>
														{item.lot}
													</TableCell>
													<TableCell component='th' scope='row' align='center'>
														<FormControl component='fieldset'>
															<RadioGroup
																aria-label='availability'
																name={item.lot}
																className={styles.radioGroup}
																value={availability['lot' + item.lot]}
																onChange={handleAvailability}
															>
																<FormControlLabel
																	value='soldout'
																	control={
																		<Radio className={styles.radioBtn} />
																	}
																	label='Sold Out'
																/>
																<FormControlLabel
																	value='pending'
																	control={
																		<Radio className={styles.radioBtn} />
																	}
																	label='Pending'
																/>
																<FormControlLabel
																	value='available'
																	control={
																		<Radio className={styles.radioBtn} />
																	}
																	label='Available'
																/>
															</RadioGroup>
														</FormControl>
													</TableCell>
													<TableCell component='th' scope='row' align='right'>
														{console.log('value: ' + personName)}
														<FormControl className={styles.formControl}>
															<Select
																labelId='demo-mutiple-chip-label'
																id='demo-mutiple-chip'
																multiple
																name={item.lot}
																value={personName['agent' + item.lot]}
																onChange={handleSalesAgent}
																input={<Input id='select-multiple-chip' />}
																renderValue={(selected) => (
																	<div className={styles.chips}>
																		{selected.map((value) => (
																			<Chip
																				key={value}
																				label={value}
																				className={styles.chip}
																			/>
																		))}
																	</div>
																)}
																MenuProps={MenuProps}
															>
																{salesAgent.map((name) => (
																	<MenuItem
																		key={name}
																		value={name}
																		style={getStyles(
																			name,
																			personName['agent' + item.lot],
																			theme
																		)}
																	>
																		{name}
																	</MenuItem>
																))}
															</Select>
														</FormControl>
													</TableCell>
												</TableRow>
											);
										})}
								</TableBody>
							</Table>
							<Modal
								show={show}
								close={closeModalHandler}
								title='Choose a client and create a document '
								buttonName='Close'
								button={closeModalHandler}
							>
								<Clients lotId={lotId} />
							</Modal>
						</>
					) : null}
					{userType === 'admin' ? (
						<>
							<Table className={styles.table} aria-label='Lot assignment table'>
								<TableHead>
									<TableRow>
										<TableCell>Lots</TableCell>
										<TableCell align='right'>Availability</TableCell>
										<TableCell align='right'>Assigned Sales Agents</TableCell>
									</TableRow>
								</TableHead>
								<TableBody>
									{console.log('list of lots: ' + JSON.stringify(listOfLots))}
									{stableSort(listOfLots, getComparator(order, orderBy))
										.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
										.map((item, index) => {
											return (
												<TableRow key={item.lot}>
													<TableCell component='th' scope='row'>
														{item.lot}
													</TableCell>
													<TableCell component='th' scope='row' align='right'>
														<FormControl component='fieldset'>
															{availability['lot' + item.lot]}
														</FormControl>
													</TableCell>
													<TableCell component='th' scope='row' align='right'>
														<div className='agent_chip_group'>
															{personName['agent' + item.lot]?.map((x) => {
																return <div className='agent_chip'>{x}</div>;
															})}
														</div>
													</TableCell>
												</TableRow>
											);
										})}
								</TableBody>
							</Table>
							<Modal
								show={show}
								close={closeModalHandler}
								title='Choose a client and create a document '
								buttonName='Close'
								button={closeModalHandler}
							>
								<Clients />
							</Modal>
						</>
					) : null}
					{userType === '' ? (
						<>
							<Table className={styles.table} aria-label='Lot assignment table'>
								<TableHead>
									<TableRow>
										<TableCell>Lots</TableCell>
										<TableCell align='right'>Availability</TableCell>
										<TableCell align='right'>Assigned Sales Agents</TableCell>
									</TableRow>
								</TableHead>
								<TableBody>
									{/* {console.log('list of lots: ' + JSON.stringify(listOfLots))} */}
									{stableSort(listOfLots, getComparator(order, orderBy))
										.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
										.map((item, index) => {
											return (
												<TableRow key={item.lot}>
													<TableCell component='th' scope='row'>
														{item.lot}
													</TableCell>
													<TableCell component='th' scope='row' align='right'>
														<FormControl component='fieldset'>
															{availability['lot' + item.lot]}
														</FormControl>
													</TableCell>
												</TableRow>
											);
										})}
								</TableBody>
							</Table>
						</>
					) : null}
				</TableContainer>
				{userType !== 'client' && (
					<TablePagination
						rowsPerPageOptions={[5, 10, 25, 50]}
						component='div'
						count={listOfLots.length}
						rowsPerPage={rowsPerPage}
						page={page}
						onChangePage={handleChangePage}
						onChangeRowsPerPage={handleChangeRowsPerPage}
						className='tablePagination'
					/>
				)}
			</div>
		</>
	);
}

export default Siteplan;
